import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * SPDX-FileCopyrightText: 2024 Genome Research Ltd.
 *
 * SPDX-License-Identifier: MIT
 */
import { useState, useEffect } from "react";
import { Widgets, httpClient, Message, Toaster, Loader, StaticMessage, } from "../..";
import Accordion from "./Accordion";
import MyBoardsHeader from "./MyBoardsHeader";
import { getUserFromLocalStorage } from "../../services/localStorage/localStorageService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { BOARD_ENDPOINTS } from "../../constants/api.constants";
const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    paddingLeft: "10px",
    paddingRight: "10px",
};
const DASHBOARD_WARNING = "WARNING: Dashboards are still in development, so existing boards or views may be removed at any point";
const getBoardDetails = async (id, setErrorMessage) => {
    try {
        const res = await httpClient().get(`/${BOARD_ENDPOINTS.BOARD}`, {
            params: {
                filter: {
                    and_: {
                        user_id: { eq: { value: id } },
                    },
                },
            },
        });
        // @ts-ignore
        const boardDetails = res.data.data.map((board) => ({
            id: board.id,
            title: board.attributes.title,
        }));
        return boardDetails;
    }
    catch (error) {
        console.warn("Error fetching boards", error);
        setErrorMessage("Error fetching boards. Please reload and try again.");
        return [];
    }
};
function MyBoards() {
    const [boardDetails, setBoardDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const toaster = Toaster();
    useEffect(() => {
        fetchBoardDetails();
    }, []);
    const errMessage = (_jsx(Message, { children: errorMessage, type: "error", showIcon: true, closable: true, styles: { marginTop: "5px" } }));
    const fetchBoardDetails = async () => {
        const user = getUserFromLocalStorage();
        const userId = user.id;
        if (userId) {
            try {
                const ids = await getBoardDetails(userId, setErrorMessage);
                setBoardDetails(ids);
            }
            catch (error) {
                console.error("Error fetching boards:", error);
                setErrorMessage("Error fetching board IDs. Please try again later.");
            }
            finally {
                setLoading(false);
            }
        }
        else {
            console.warn("User ID not found.");
            setErrorMessage("User ID not found. Please reload and try again.");
        }
    };
    useEffect(() => {
        if (errorMessage) {
            toaster.push(errMessage);
        }
    }, [errorMessage]);
    const noBoards = (_jsx("div", { style: { textAlign: "center" }, children: _jsx("div", { style: { marginTop: "60px" }, children: _jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faCircleInfo, size: "3x", style: { color: "#C2D3CD" } }), _jsx("p", { style: { marginTop: "5px", fontSize: "16px" }, children: "You have no boards yet. Click the button to create or import a new board to get started." })] }) }) }));
    const myBoards = (_jsx("div", { className: "my-boards-container", children: !loading ? (boardDetails && boardDetails.length > 0 ? (_jsx(Accordion, { boardDetails: boardDetails, setBoardDetails: setBoardDetails })) : (_jsx("div", { children: noBoards }))) : (_jsx("div", { className: "fixed-full-page", children: _jsxs("div", { className: "fixed-centered-loader", children: [_jsx("span", { style: { display: "flex", justifyContent: "center" }, children: _jsx(Loader, {}) }), _jsx("p", { style: { marginTop: "10px" }, children: "Loading Your Boards..." })] }) })) }));
    const myBoardsHeader = _jsx(MyBoardsHeader, { containerStyle: containerStyle });
    const myBoardsWarning = (_jsx("div", { style: { padding: "0px 10px" }, children: _jsx(StaticMessage, { message: DASHBOARD_WARNING, type: "warning" }) }));
    const components = [
        {
            component: myBoardsHeader,
            type: "full",
        },
        {
            component: myBoards,
            type: "full",
        },
    ];
    return (_jsxs(_Fragment, { children: [myBoardsWarning, _jsx(Widgets, { components: components })] }));
}
export default MyBoards;
